import { render, staticRenderFns } from "./v-custom-field.vue?vue&type=template&id=a2a4aae8&"
import script from "./v-custom-field.vue?vue&type=script&lang=js&"
export * from "./v-custom-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports